import React from 'react';
import AdminAlertsPanel from '../components/AdminAlertsPanel';

export default function AdminPartnerAlerts() {
  return <AdminAlertsPanel category="partner" title="Partner Alerts" subtitle="Partner activity and referral updates" />;
}
